import React from 'react';
import { Box } from '@mui/material';
import ServicePresetStep from './ServicePresetStep';
import type { ServicePreset } from './types';

interface SetupStepProps {
  selectedPreset: ServicePreset | null;
  onSelectPreset: (preset: ServicePreset) => void;
}

export default function SetupStep({ selectedPreset, onSelectPreset }: SetupStepProps) {
  return (
    <Box sx={{ maxWidth: 980, mx: 'auto', display: 'grid', gap: 3 }}>
      <ServicePresetStep selectedPreset={selectedPreset} onSelect={onSelectPreset} />
    </Box>
  );
}
